import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = [
  {
    group: 'ප්‍රධාන',
    items: [
      {
        to: '/',
        label: 'උපකරණ පුවත්පත',
        show: 'all',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
        ),
      },
    ],
  },
  {
    group: 'නඩත්තු',
    items: [
      {
        to: '/maintenance',
        label: 'නඩත්තු වාර්තා',
        show: 'all',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        ),
      },
      {
        to: '/maintenance/new',
        label: 'නව වාර්තාව',
        show: 'adminOrAbove',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 4v16m8-8H4"/>
          </svg>
        ),
      },
    ],
  },
  {
    group: 'කළමනාකරණය',
    items: [
      {
        to: '/schools',
        label: 'පාසල්',
        show: 'adminOrAbove',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
          </svg>
        ),
      },
      {
        to: '/employees',
        label: 'නිලධාරීන්',
        show: 'adminOrAbove',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        ),
      },
      {
        to: '/users',
        label: 'පරිශීලකයන්',
        show: 'superAdmin',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
        ),
      },
      {
  to: '/activity-log',
  label: 'Activity Log',
  show: 'superAdmin',
  icon: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
    </svg>
  ),
},
    ],
  },
];

export default function Sidebar() {
  const { pathname } = useLocation();
  const { isSuperAdmin, isAdminOrAbove } = useAuth();

  const canShow = (show) => {
    if (show === 'all')          return true;
    if (show === 'adminOrAbove') return isAdminOrAbove;
    if (show === 'superAdmin')   return isSuperAdmin;
    return false;
  };

  return (
    <aside className="w-60 min-h-full bg-white border-r border-gray-200 flex-shrink-0">
      <div className="p-4 space-y-6">
        {menuItems.map(({ group, items }) => {
          const visibleItems = items.filter(i => canShow(i.show));
          if (!visibleItems.length) return null;

          return (
            <div key={group}>
              {/* Group Label */}
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 mb-2">
                {group}
              </p>

              {/* Items */}
              <div className="space-y-1">
                {visibleItems.map(({ to, label, icon }) => {
                  const isActive = pathname === to;
                  return (
                    <Link
                      key={to}
                      to={to}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                        isActive
                          ? 'bg-red-50 text-red-600'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                    >
                      <span className={isActive ? 'text-red-500' : 'text-gray-400'}>
                        {icon}
                      </span>
                      {label}
                      {isActive && (
                        <span className="ml-auto w-1.5 h-1.5 rounded-full bg-red-500"></span>
                      )}
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
}